import React, { useState } from "react";
import Table from "../../Common/Table";
import TableFieldsIssuedList from "../../../constants/DriverMedals/TableMedals.json";
import MetricChangeLogsFields from "../../../constants/DriverMedals/MetricChangeLogs.json";
import Modal from "../../Common/NoFooterModal";
import moment from "moment";
import { isValNull } from "../../../utils";

const MedalsList = (props) => {
  const { list } = props;
  const [modalOpen, setModalOpen] = useState(false);
  const [activeItem, setActiveItem] = useState({});

  const getFieldValue = (item, key) => {
    switch (key) {
      case "change_logs":
        return (
          <span onClick={() => handleRowClick(item)} className="edit-options">
            View
          </span>
        );
      case "timestamp":
        return !isValNull(item[key])
          ? moment(item[key]).format("DD-MM-YYYY hh:mm A")
          : "";
      default:
        return item[key];
    }
  };

  const handleRowClick = (item) => {
    setActiveItem(item);
    setModalOpen(true);
  };
  const handleClose = () => {
    setActiveItem({});
    setModalOpen(false);
  };

  return (
    <>
      <Table
        list={list}
        getFieldValue={getFieldValue}
        fields={TableFieldsIssuedList}
      />
      {modalOpen && (
        <Modal
          header={true}
          heading="Change logs"
          id="DriverMedalChangeLogsModal"
          handleClose={handleClose}
        >
          <Table
            list={activeItem["logs"]}
            getFieldValue={getFieldValue}
            fields={MetricChangeLogsFields}
          />
        </Modal>
      )}
    </>
  );
};

export default MedalsList;
